const initialState = {
  isFetching: false,
  isFetched: false,
  isError: false,
  isSuccess: false,
  data: {}
}

export const ACTION_TYPES = {
  INVESTOR_PROFILE_REQUEST: 'INVESTOR_PROFILE_REQUEST',
  INVESTOR_PROFILE_SUCCESS: 'INVESTOR_PROFILE_SUCCESS',
  INVESTOR_PROFILE_ERROR: 'INVESTOR_PROFILE_ERROR'
}

export const getInvestorProfile = () => ({
  type: ACTION_TYPES.INVESTOR_PROFILE_REQUEST
})

const investorProfile = (state = initialState, { type, payload }) => {
  switch (type) {
    case ACTION_TYPES.INVESTOR_PROFILE_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case ACTION_TYPES.INVESTOR_PROFILE_SUCCESS:
      return {
        ...state,
        data: payload.data,
        isFetching: false,
        isFetched: true,
        isError: false,
        isSuccess: true
      }
    case ACTION_TYPES.INVESTOR_PROFILE_ERROR:
      return {
        ...state,
        isFetching: false,
        isFetched: true,
        isError: true,
        isSuccess: false
      }
    default:
      return state
  }
}

export default investorProfile
